import { HashRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../dashboard/Dashboard";
import Layout from "../layout/Layout";
import RoleRoute from "./RoleRoute";
import Users from "../users/Users";
import Leads from "../leads/Leads";
import LeadDetails from "../leads/LeadDetails";
import FollowupsPage from "../followups/FollowupsPage";
import Sales from "../sales/Sales";
import Reports from "../report/Report";
import Projects from "../projects/ProjectList";
import CallLogs from "../IVRCallLogs/CallLogs";
import CallAnalytics from "../IVRCallLogs/getCallAnalytics";
import AddAgent from "../IVRCallLogs/AddAgent";

const AppRoutes = () => {
   return (
      <HashRouter>
         <Routes>
            <Route path="/" element={<Login />} />

            <Route
               path="/dashboard"
               element={
                  <RoleRoute allowedRoles={["admin", "staff"]}>
                     <Layout>
                        <Dashboard />
                     </Layout>
                  </RoleRoute>
               }
            />

            <Route
               path="/users"
               element={
                  <RoleRoute allowedRoles={["admin"]}>
                     <Layout>
                        <Users />
                     </Layout>
                  </RoleRoute>
               }
            />

            <Route
               path="/leads"
               element={
                  <RoleRoute allowedRoles={["admin", "staff"]}>
                     <Layout>
                        <Leads />
                     </Layout>
                  </RoleRoute>

               }
            />

            <Route
               path="/leads/:id"
               element={
                  <RoleRoute allowedRoles={["admin", "staff"]}>
                     <Layout>
                        <LeadDetails />
                     </Layout>
                  </RoleRoute>
               }
            />

            <Route
               path="/followups"
               element={
                  <RoleRoute allowedRoles={["admin", "staff"]}>
                     <Layout>
                        <FollowupsPage />
                     </Layout>
                  </RoleRoute>
               }
            />

            <Route
               path="/sales"
               element={
                  <RoleRoute allowedRoles={["admin", "staff"]}>
                     <Layout>
                        <Sales />
                     </Layout>
                  </RoleRoute>
               }
            />

            <Route path="/reports" element={
               <RoleRoute allowedRoles={["admin", "staff"]}>
                  <Layout>
                     <Reports />
                  </Layout>
               </RoleRoute>
            }
            />


            <Route path="/projects" element={
               <RoleRoute allowedRoles={["admin"]}>
                  <Layout>
                     <Projects />
                  </Layout>

               </RoleRoute>

            } />

            <Route path="/call-logs" element={
               <RoleRoute allowedRoles={["admin"]}>
                  <Layout>
                     <CallLogs />
                  </Layout>

               </RoleRoute>

            } />

            <Route path="/calldashboard" element={
               <RoleRoute allowedRoles={["admin"]}>
                  <Layout>
                     <CallAnalytics />
                  </Layout>

               </RoleRoute>

            } />
            <Route path="/addagent" element={
               <RoleRoute allowedRoles={["admin"]}>
                  <Layout>
                     <AddAgent />
                  </Layout>

               </RoleRoute>

            } />
         </Routes>
      </HashRouter >
   );
};

export default AppRoutes;
